import styles from './index.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { MochiButton } from '@autopass-web/mochi-component';
import amplitude from '#/guest-aps/services/amplitude';
import { PageContainer } from '#/guest-aps/components/page-container';
import { PATH } from '#/guest-aps/config';
import FeaturePromotion from '@autopass-web/feature-promotion';
import { environment } from '../../environments/environment';

export const PromotionPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <PageContainer>
      <div className={styles['bar']}>
        停車線上繳費優惠
        <MochiButton
          variant="text"
          onClick={() => {
            const promotionDetail = location.pathname.includes('detail')
              ? { id: location.pathname.split('/')[3] }
              : null;
            amplitude.promotionLeaveOnClick(promotionDetail);
            navigate(PATH.SEARCH_PLATE_NUMBER);
          }}
        >
          前往繳費
        </MochiButton>
      </div>
      <div className={styles['promotion']}>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <FeaturePromotion
          locationSearch={window.origin}
          nextModule={false}
          basePath="/promotion"
          app="guest-aps"
          env={{
            analyticsKey: environment.amplitudeKey,
          }}
        />
      </div>
    </PageContainer>
  );
};
